import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import ZapierPage from "@tmu/components/zapier"
import PrivateRoute from "@tmu/components/PrivateRoute"

const Zapier = () => {
  return <PrivateRoute component={ZapierPage} path="/*" />
}

export default injectIntl(Zapier)
